import React, { useState } from 'react';
import { IconButton, Icon, Box } from '@material-ui/core';
import useStyles from './styles';
import clsx from 'clsx';
import { get } from 'global/lib/lodash';
import { Loader } from 'global/styles';
import { executePrint } from '../../utils';
import { useView } from '../../hooks/useView';

export * from './print-view';

export default (props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [toggled, setToggled] = useState(false);
  const { isDark, toggleTheme } = useView();

  const print = () => {
    if (loaded) {
      executePrint();
      if (toggled) {
        toggleTheme();
        setToggled(false);
      }
    }

    const onPrint = get(props, 'onPrint');
    if (onPrint) {
      setLoading(true);
      onPrint()
        .then(() => {
          setLoading(false);
          setLoaded(true);
          setToggled(isDark);
          isDark && toggleTheme();
        })
        .catch((err) => {
          setLoading(false);
          setLoaded(false);
          toggled && toggleTheme();
          setToggled(false);
        });
    } else {
      executePrint();
    }
  };

  const getIcon = () => {
    if (loading) {
      return <Loader size={18} />;
    } else if (loaded) {
      return (
        <div className={classes.printIconContainer}>
          <Icon>print</Icon>
          <Icon className={classes.checkIcon}>check_circle</Icon>
        </div>
      );
    } else {
      return <Icon>print</Icon>;
    }
  };

  return (
    <Box displayPrint="none" className={clsx(classes.container, props.className)}>
      <IconButton onClick={print} color={'inherit'}>
        {getIcon()}
      </IconButton>
    </Box>
  );
};
